import { NavigationTabs } from '@common/components/NavigationTabs/NavigationTabs';
import { NavigationTabsOption } from '@common/types/link';
import { TableTabTrigger } from './TableTabTrigger';
import { useTabUrl } from '@common/hooks/useTabUrl';
import { Tabs } from '@radix-ui/themes';

interface TableTabControlProps<T extends string> {
    options: NavigationTabsOption<T>[];
    defaultValue?: T;
}

export const TableTabControl = <T extends string>({
    options,
    defaultValue,
}: TableTabControlProps<T>) => {
    const { currentTab } = useTabUrl(options, defaultValue);

    return (
        <Tabs.Root value={currentTab}>
            <Tabs.List>
                <NavigationTabs options={options} defaultValue={defaultValue}>
                    <TableTabTrigger />
                </NavigationTabs>
            </Tabs.List>
        </Tabs.Root>
    );
};
